import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';

export default function useGetDragAndDropApi(id, filterValue) {
  return useQuery(
    ['get-all-buckets', id, filterValue],
    async () => {
      const res = await makeApiRequest.get(
        createQueryParamsForGetReq(apiEndPoints.DRAG_AND_DROP_API, {
          filter_type: filterValue,
          task_board_id: id,
        })
      );
      return res.data;
    },
    {
      enabled: id ? true : false,
    }
  );
}
